export default __webpack_public_path__ + "static/media/appstore.06a0b4de.png";